import type { Rate } from '../domain/types';
import { config } from '../api/config';

type TariffListProps = {
  rates: Rate[];
  selected: Rate | null;
  onSelect: (rate: Rate) => void;
};

function formatPrice(value: number): string {
  return `${Math.round(value)} ${config.defaultCurrency}`;
}

export function TariffList({ rates, selected, onSelect }: TariffListProps) {
  return (
    <ul className="tariff-list">
      {rates.map((rate) => {
        const isSelected = selected?.rate === rate.rate;
        const hasDiscount = rate.priceBeforeDiscount > rate.price;
        const saved = hasDiscount ? Math.round(rate.priceBeforeDiscount - rate.price) : 0;
        return (
          <li
            key={rate.rate}
            className={`tariff-item${isSelected ? ' selected' : ''}`}
            onClick={() => onSelect(rate)}
          >
            <div className="tariff-info">
              <span className="tariff-name">{rate.vehicleType ?? 'Базовий'}</span>
              {hasDiscount && (
                <span className="tariff-discount">−{saved} {config.defaultCurrency}</span>
              )}
            </div>
            <span className="tariff-price">
              {hasDiscount && (
                <s className="tariff-old">{formatPrice(rate.priceBeforeDiscount)}</s>
              )}
              {formatPrice(rate.price)}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
